import type { BusinessAnalyticsRow } from '@/pages/B2B/business-analytics/api/useBusinessAnalytics';

export interface MetricDef {
  key: string;
  label: string;
  group: 'Foot traffic' | 'Events' | 'Deals';
  accessor: (row: BusinessAnalyticsRow) => number;
  format: (n: number) => string;
}

const num = (n: number): string => n.toLocaleString();

export function formatMinutes(mins: number): string {
  const m = Math.max(0, Math.round(mins));
  if (m < 60) return `${m}m`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

const safe = (v: number | null | undefined): number => (typeof v === 'number' ? v : 0);

export const METRIC_CATALOG: MetricDef[] = [
  // Foot traffic
  { key: 'check_ins_total', label: 'Most Check-ins', group: 'Foot traffic',
    accessor: (r) => safe(r.check_ins_total), format: num },
  { key: 'check_ins_distinct_users', label: 'Most Unique Visitors', group: 'Foot traffic',
    accessor: (r) => safe(r.check_ins_distinct_users), format: num },
  { key: 'live_minutes_total', label: 'Most Live Time', group: 'Foot traffic',
    accessor: (r) => safe(r.live_minutes_total), format: formatMinutes },
  { key: 'peak_concurrent', label: 'Highest Peak Crowd', group: 'Foot traffic',
    accessor: (r) => safe(r.peak_concurrent), format: num },
  { key: 'live_check_in_distinct_users', label: 'Most Live Visitors', group: 'Foot traffic',
    accessor: (r) => safe(r.live_check_in_distinct_users), format: num },
  { key: 'favorites_total', label: 'Most Favorited', group: 'Foot traffic',
    accessor: (r) => safe(r.favorites_total), format: num },
  // Events
  { key: 'event_interests_going', label: 'Most "Going" RSVPs', group: 'Events',
    accessor: (r) => safe(r.event_interests_going), format: num },
  { key: 'event_interests_interested', label: 'Most "Interested"', group: 'Events',
    accessor: (r) => safe(r.event_interests_interested), format: num },
  { key: 'events_completed', label: 'Most Events Hosted', group: 'Events',
    accessor: (r) => safe(r.events_completed), format: num },
  { key: 'event_actual_attendees_total', label: 'Most Event Attendees', group: 'Events',
    accessor: (r) => safe(r.event_actual_attendees_total), format: num },
  // Deals
  { key: 'deal_views_total', label: 'Most Deal Views', group: 'Deals',
    accessor: (r) => safe(r.deal_views_total), format: num },
];
